const NIVEL_SERVICO_MAP = {
  "NIVEL ELEVADO": "NÍVEL ELEVADO",
  "NIVEL ALTO": "NÍVEL ALTO",
  "NIVEL MEDIO": "NÍVEL MÉDIO",
  "NIVEL BAIXO": "NÍVEL BAIXO",
  "NIVEL ORDINARIO": "NÍVEL ORDINÁRIO",
  "SOB ENCOMENDA": "SOB ENCOMENDA",
};

export default {
  computed: {
    nivel_servico() {
      return NIVEL_SERVICO_MAP;
    },
  },

  methods: {
    verificarNivelServico(status) {
      return NIVEL_SERVICO_MAP[status] || status;
    },
  },
};
